<div
  class="slide-viewer"
  style="display: flex"
  (mouseenter)="mouseOut()"
  (mouseleave)="addSceneIndex = undefined"
>
  <!-- <div class="slide-header flex-row gap-6">
    <div class="line"></div>
    <div class="flex-row gap-2" style="height: 24px">
      <div style="width: 20px">
        <nw-icon
          type="fast_rewind"
          [size]="fastRewindHover ? 16 : 13"
          (mouseenter)="fastRewindHover = true"
          (mouseleave)="fastRewindHover = false"
          (click)="goToPrevFrame()"
        ></nw-icon>
      </div>
      <div style="width: 20px">
        <nw-icon
          type="play_arrow"
          [size]="playArrowHover ? 20 : 16"
          (mouseenter)="playArrowHover = true"
          (mouseleave)="playArrowHover = false"
          (click)="playFrames()"
        ></nw-icon>
      </div>
      <div style="width: 20px">
        <nw-icon
          type="fast_forward"
          [size]="fastForwardHover ? 16 : 13"
          (mouseenter)="fastForwardHover = true"
          (mouseleave)="fastForwardHover = false"
          (click)="goToNextFrame()"
        ></nw-icon>
      </div>
    </div>
    <div class="line"></div>
  </div> -->
  <div class="slides-container" style="margin: 0 auto">
    <nw-slide-item
      *ngFor="let item of scenes$ | async; let i = index"
      [index]="i"
      [slide]="item"
    ></nw-slide-item>

    <!-- <nw-slide-item [newSceneMode]="true"></nw-slide-item> -->
  </div>
  <div style="position: relative; display: table; margin-left: 16px">
    <!-- <div
      *ngIf="currentTime$ | async"
      class="time-pin"
      [style.left.px]="(currentTime$ | async) - 7"
    ></div> -->
  </div>
</div>
